import 'bootstrap/dist/css/bootstrap.min.css';
import 'datatables.net';
import 'datatables.net-buttons';
import 'datatables.net-buttons-dt/css/buttons.dataTables.min.css';
import 'datatables.net-buttons/js/buttons.colVis';
import 'datatables.net-buttons/js/buttons.html5';
import 'datatables.net-buttons/js/buttons.print';
import axios from 'axios';
import $ from 'jquery';
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { baseurl } from '../utility/helper';
import { authCtx, rupee, formatDate, CHAPTER_ADMIN } from '../utility/instituteHelpers';
import '../assets/css/Institute.css';

const BatchList = () => {
  const navigate = useNavigate();
  const { roleid, chapterId } = authCtx();
  const tableRef = useRef(null);

  const [institutes, setInstitutes] = useState([]);
  const [selectedInstitute, setSelectedInstitute] = useState('');
  const [statusFilter, setStatusFilter] = useState('');

  useEffect(() => {
    axios.get(`${baseurl}/admin/institutes`)
      .then((res) => setInstitutes(res.data || []))
      .catch((err) => console.error('Error fetching institutes:', err));
  }, []);

  const fetchBatches = async () => {
    try {
      const params = {};
      if (roleid === CHAPTER_ADMIN && chapterId) params.chapterId = chapterId;
      if (statusFilter) params.status = statusFilter;
      const url = selectedInstitute
        ? `${baseurl}/admin/institutes/${selectedInstitute}/batches`
        : `${baseurl}/admin/batches`;
      const res = await axios.get(url, { params });
      renderTable(res.data || []);
    } catch (err) {
      console.error('Error fetching batches:', err);
    }
  };

  const renderTable = (data) => {
    const el = tableRef.current;
    if (!el) return;

    if ($.fn.DataTable.isDataTable(el)) {
      const t = $(el).DataTable();
      t.clear();
      t.rows.add(data);
      t.draw();
      return;
    }

    $(el).DataTable({
      dom: 'Blfrtip',
      pageLength: 25,
      lengthMenu: [[10, 25, 50, 100, 250, 500, -1], [10, 25, 50, 100, 250, 500, 'All']],
      buttons: [
        { extend: 'copyHtml5', className: 'btn btn-primary dttable', exportOptions: { columns: ':visible' } },
        { extend: 'excelHtml5', className: 'btn btn-primary dttable', exportOptions: { columns: ':visible' } },
        { extend: 'csvHtml5', className: 'btn btn-primary dttable', exportOptions: { columns: ':visible' } },
        { extend: 'pdfHtml5', className: 'btn btn-primary dttable', exportOptions: { columns: ':visible' } },
        { extend: 'print', className: 'btn btn-primary dttable', exportOptions: { columns: ':visible' } },
      ],
      data,
      columns: [
        { data: 'batch_id', title: 'ID' },
        { data: 'batch_name', title: 'Batch' },
        { data: 'batch_code', title: 'Code' },
        { data: 'institute_name', title: 'Institute' },
        { data: 'requested_fee', title: 'Requested Fee', render: (d) => rupee(d) },
        { data: 'approved_fee_snapshot', title: 'Approved Snapshot', render: (d) => rupee(d) },
        { data: 'fee_difference', title: 'Diff', render: (d) => (Number(d) === 0 ? '—' : rupee(d)) },
        { data: 'start_date', title: 'Start', render: (d) => (d ? formatDate(d) : '—') },
        { data: 'end_date', title: 'End', render: (d) => (d ? formatDate(d) : '—') },
        { data: 'status', title: 'Status' },
        { data: null, title: 'Action', orderable: false, searchable: false },
      ],
      columnDefs: [
        {
          targets: 0,
          render: (data) => `<a href="#" class="edit-link" data-id="${data}">${data}</a>`,
        },
        {
          targets: 1,
          render: (data, type, row) =>
            `<a href="#" class="dash-link" data-id="${row.batch_id}">${data}</a>`,
        },
        {
          targets: 9,
          render: (data) => {
            const key = String(data || '').toLowerCase().replace(/\s+/g, '');
            const cls = key === 'pendingapproval' ? 'pending' : (key || 'draft');
            return `<span class="inst-badge ${cls}">${data || '—'}</span>`;
          },
        },
        {
          targets: -1,
          render: (data, type, row) =>
            `<button class="btn btn-primary btn-sm dash-btn" data-id="${row.batch_id}">Dashboard</button>`,
        },
      ],
      order: [[0, 'desc']],
      initComplete: function () {
        $('.dt-length select').addClass('form-select form-select-sm');
      },
    });
  };

  useEffect(() => {
    const goDash = function (e) { e.preventDefault(); navigate('/admin/BatchDashboard', { state: { batchId: $(this).data('id') } }); };
    const goEdit = function (e) { e.preventDefault(); navigate('/admin/BatchForm', { state: { batchId: $(this).data('id'), edit: true } }); };

    $(document).off('click', '#batch-list .edit-link').on('click', '#batch-list .edit-link', goEdit);
    $(document).off('click', '#batch-list .dash-link').on('click', '#batch-list .dash-link', goDash);
    $(document).off('click', '#batch-list .dash-btn').on('click', '#batch-list .dash-btn', goDash);

    return () => {
      $(document).off('click', '#batch-list .edit-link');
      $(document).off('click', '#batch-list .dash-link');
      $(document).off('click', '#batch-list .dash-btn');
      if (tableRef.current && $.fn.DataTable.isDataTable(tableRef.current)) {
        $(tableRef.current).DataTable().destroy();
      }
    };
    // eslint-disable-next-line
  }, []);

  useEffect(() => { fetchBatches(); /* eslint-disable-next-line */ }, [selectedInstitute, statusFilter]);

  return (
    <div className="content container-fluid inst-wrap" id="batch-list">
      <center><h2><b>Batches</b></h2></center>

      <div className="inst-card">
        <div className="row g-3 align-items-end">
          <div className="col-md-4">
            <label className="form-label">Institute</label>
            <select className="form-select" value={selectedInstitute}
              onChange={(e) => setSelectedInstitute(e.target.value)}>
              <option value="">All institutes</option>
              {institutes.map((i) => (
                <option key={i.institute_id} value={i.institute_id}>{i.name} — {i.location}</option>
              ))}
            </select>
          </div>
          <div className="col-md-3">
            <label className="form-label">Status</label>
            <select className="form-select" value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)}>
              <option value="">All</option>
              {['Draft', 'Pending Approval', 'Approved', 'Active', 'Rejected', 'Completed', 'Cancelled']
                .map((s) => <option key={s} value={s}>{s}</option>)}
            </select>
          </div>
          <div className="col-md-5 text-md-end">
            <button className="btn btn-primary"
              onClick={() => navigate('/admin/BatchForm', { state: { instituteId: selectedInstitute || null } })}>
              <i className="bx bxs-plus-circle" /> Add Batch
            </button>
          </div>
        </div>
      </div>

      <div className="inst-card">
        <div className="inst-table-scroll">
          <table ref={tableRef} className="table table-striped table-bordered" style={{ width: '100%' }}>
            <thead>
              <tr>
                <th>ID</th><th>Batch</th><th>Code</th><th>Institute</th>
                <th>Requested Fee</th><th>Approved Snapshot</th><th>Diff</th>
                <th>Start</th><th>End</th><th>Status</th><th>Action</th>
              </tr>
            </thead>
            <tbody></tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default BatchList;
